import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { StatisticCardShell } from './statistic-card-shell';

const StyledErrorBody = styled(Stack)(() => ({
  flex: 1,
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledErrorText = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(12),
  fontWeight: 400,
  lineHeight: 1.4,
  color: theme.palette.text.second,
  textAlign: 'center',
}));

/**
 * Error placeholder for a statistic card when the API request failed.
 * Preserves the card shell dimensions so the layout does not shift.
 */
export const StatisticCardError: FC = () => {
  const { t } = useTranslation('communityStats');

  return (
    <StatisticCardShell>
      <StyledErrorBody>
        <StyledErrorText>{t('statisticCards.errorState')}</StyledErrorText>
      </StyledErrorBody>
    </StatisticCardShell>
  );
};
